"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class MundiPagg extends Parse.Object {
    constructor(attributes) {
        super('MundiPagg', attributes);
    }
    get installmentsWithoutInterest() { return this.get('installmentsWithoutInterest'); }
    set installmentsWithoutInterest(value) { this.set('installmentsWithoutInterest', value); }
    get minimumInstallmentValue() { return this.get('minimumInstallmentValue'); }
    set minimumInstallmentValue(value) { this.set('minimumInstallmentValue', value); }
    get canAcceptBoleto() { return this.get('canAcceptBoleto'); }
    set canAcceptBoleto(value) { this.set('canAcceptBoleto', value); }
    get boletoMinimumOrderTotal() { return this.get('boletoMinimumOrderTotal'); }
    set boletoMinimumOrderTotal(value) { this.set('boletoMinimumOrderTotal', value); }
    get boletoExpirationDays() { return this.get('boletoExpirationDays'); }
    set boletoExpirationDays(value) { this.set('boletoExpirationDays', value); }
    get boletoMaxInstallments() { return this.get('boletoMaxInstallments'); }
    set boletoMaxInstallments(value) { this.set('boletoMaxInstallments', value); }
    get boletoInstructions() { return this.get('boletoInstructions'); }
    set boletoInstructions(value) { this.set('boletoInstructions', value); }
    /** The bank number to be used by MundiPagg to create the boleto */
    get boletoBankNumber() { return this.get('boletoBankNumber'); }
    set boletoBankNumber(value) { this.set('boletoBankNumber', value); }
    get retailer() { return this.get('retailer'); }
    set retailer(value) { this.set('retailer', value); }
    get mundiPaggSecure() { return this.get('mundiPaggSecure'); }
    set mundiPaggSecure(value) { this.set('mundiPaggSecure', value); }
}
exports.MundiPagg = MundiPagg;
Parse.Object.registerSubclass('MundiPagg', MundiPagg);
//# sourceMappingURL=MundiPagg.js.map